import React, { createContext, FC, useState } from 'react'
import { Lesson } from '@contexts/autogenerate/graphql'

interface CourseContextState {
  selectedLesson: any
  selectedModule: any
  setSelectedLesson: Function
  setSelectedModule: Function
}

export const defaultCourseContextState = {
  selectedLesson: null,
  selectedModule: null,
  setSelectedLesson: () => {},
  setSelectedModule: () => {},
}

export const CourseContext = createContext<CourseContextState>(
  defaultCourseContextState
)

export const CourseStateProvider: FC = ({ children }) => {
  const [selectedLesson, setSelectedLesson] =
    useState<undefined | Lesson>(undefined)

  const [selectedModule, setSelectedModule] =
    useState<undefined | Lesson>(undefined)

  return (
    <CourseContext.Provider
      value={{
        selectedModule,
        selectedLesson,
        setSelectedLesson,
        setSelectedModule,
      }}
    >
      {children}
    </CourseContext.Provider>
  )
}
